<template lang="html">
  <body data-spy="scroll" data-target="#navbar" data-offset="98" v-on:scroll="toggleFixedHeader">
    <div>
      <head-component/>
      <!-- loading-overlay /> -->
      <section id="home" class="home-banner-02 theme-bg">
        <div class="home-efftect">
          <img :src="require('../assets/landing/bg-home-effect-1.svg')" title="" alt="">
        </div>
        <div class="container container-larage">
          <div class="row justify-content-center align-items-center full-screen p-80px-tb">
            <div class="col-lg-5">
              <div class="banner-text p-50px-t md-p-80px-t sm-p-40px-t">
                <h2 class="font-alt dark-color">A better way to document code.</h2>
                <p>Codoc is a documentation system built around your code. </p>
                <div class="btn-bar" v-if="false">
                  <!-- TODO: Replace this with a component that has tracking -->
                  <a class="btn btn-theme" href="/demo">View Codoc Demo</a>
                  <p class="subtitle m-10px-t">No signup needed</p>
                </div>
                <div>
                  <get-started-form />
                </div>
              </div>
            </div> <!-- col -->
            <div class="col-lg-7 p-60px-t">
              <!-- <img :src="require('../assets/landing/how-hero.svg')" title="" alt=""> -->
              <lightbox
                :thumbnail="require('../assets/landing/mp1.png')"
                :images="[require('../assets/landing/mp1_md.png')]"
              >
                <lightbox-default-loader slot="loader"></lightbox-default-loader> <!-- If you want to use built-in loader -->
                <!-- <div slot="loader"></div> --> <!-- If you want to use your own loader -->
              </lightbox>
            </div> <!-- col -->
          </div> <!-- row -->
        </div>
      </section>
      <section class="theme-bg highlight-section p-40px">
        <div class="container-fluid ">
          <div class="row justify-content-center m-35px-tb ">
            <div class="col col-sm-8">
            <h2 class="font-alt">Say goodbye to scattered and out-of-date documentation.</h2>
          </div>
          </div>
        </div>
      </section>
      <section id="about" class="section border-bottom gray-bg-g shapes-section bo">
    <div class="container">
      <div class="row justify-content-center m-45px-b md-m-25px-b">
          <div class="col-md-10 col-lg-8 col-xl-7">
            <div class="section-title text-center">
              <h2 class="dark-color font-alt">How Codoc Works</h2>
              <p v-if="false">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
            </div>
          </div> <!-- col -->
      </div>

      <div class="row">
        <div class="col-md-4 m-15px-tb">
          <div class="feature-box theme-hover box-shadow">
            <div class="icon">
              <i class="ti-harddrives theme-color"></i>
            </div>
            <div class="feature-content">
              <h4 class="dark-color font-alt">Connect your Codebase</h4>
              <p>Codoc can read repositories from GitHub, GitLab, BitBucket and more.</p>
            </div>
          </div>
        </div> <!-- col -->

        <div class="col-md-4 m-15px-tb">
          <div class="feature-box theme-hover box-shadow">
            <div class="icon">
              <i class="ti-time theme-color"></i>
            </div>
            <div class="feature-content">
              <h4 class="dark-color font-alt">Setup Reminders</h4>
              <p>With new pull requests, set reminders for relevant engineers to easily add documentation.</p>
            </div>
          </div>
        </div> <!-- col -->

        <div class="col-md-4 m-15px-tb">
          <div class="feature-box theme-hover box-shadow">
            <div class="icon">
              <i class="ti-desktop theme-color"></i>
            </div>
            <div class="feature-content">
              <h4 class="dark-color font-alt">Use Codoc Viewer</h4>
              <p>View your codebase with all relevant documentation online.</p>
            </div>
          </div>
        </div> <!-- col -->
      </div> <!-- row -->
    </div>
  </section>
      <!--
      <section id="how" class="section border-bottom gray-bg-g shapes-section">
      </section>
    -->
        <section id="how" class="section gray-bg border-top" v-if="false">
          <div class="container">
            <div class="row justify-content-center m-0px-b md-m-0px-b">
                <div class="col-md-10 col-lg-8 col-xl-7">
                  <div class="section-title text-center">
                    <h2 class="dark-color font-alt">How Dana Works</h2>
                    <p>It's not easy to stay on top of things. Access Dana through your phone or email and make relationships easier.</p>
                  </div>
                </div>
            </div>
          </div>
          <div class="container">
            <div class="row m-40px-t">
              <div class="col-md-12">
                <div class="tab-style-1">
                  <ul class="nav nav-fill" id="pills-tab" role="tablist">
                    <li class="nav-item">
                      <a class="nav-link theme-after active show" id="pills-Features-tab" data-toggle="pill" href="#pills-Features" role="tab" aria-controls="pills-Features" aria-selected="true">Create a Contact</a>
                    </li>

                    <li class="nav-item">
                      <a class="nav-link theme-after" id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="false">Create a Meeting</a>
                    </li>
                    <!-- <li class="nav-item">
                      <a class="nav-link theme-after" id="pills-profile-tab" data-toggle="pill" href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">Info + Reminders</a>
                    </li> -->
                  </ul>

                  <div class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade active show" id="pills-Features" role="tabpanel" aria-labelledby="pills-Features-tab">
                      <div class="row align-items-center">
                        <div class="col-md-6 sm-m-30px-t">
                          <div class="side-title p-50px-l md-p-0px-l">
                            <h2 class="dark-color sub-title m-0px m-20px-b">Start with creating a contact</h2>
                            <p class="large-text">Dana needs to know who you'd like to keep in touch with.  You can also import your contacts from Gmail, LinkedIn, iCloud, or even a .CSV file.</p>
                            <div class="p-15px-t">
                              <!-- <a class="btn btn-theme" href="#">Get Started</a> -->
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <img src="static/img/767x767.jpg" title="" alt="">
                        </div> <!-- col -->
                      </div> <!-- row -->
                    </div><!-- tab content -->

                    <div class="tab-pane fade" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                      <div class="row align-items-center">
                        <div class="col-md-6 sm-m-30px-t">
                          <div class="side-title p-50px-l md-p-0px-l">
                            <h2 class="dark-color sub-title m-0px m-20px-b">Let Dana know when you have meetings</h2>
                            <p class="large-text">Create meetings manually or connect your calendar have Dana automatically import events.</p>
                            <div class="p-15px-t">
                              <!-- <a class="btn btn-theme" href="#">Get Free Try Now</a> -->
                            </div>
                          </div>
                        </div> <!-- col -->

                        <div class="col-md-6">
                          <img src="static/img/767x767.jpg" title="" alt="">
                        </div> <!-- col -->

                      </div> <!-- row -->
                    </div> <!-- tab content -->
                    <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                      <div class="row align-items-center">
                        <div class="col-md-6">
                          <img src="static/img/767x767.jpg" title="" alt="">
                        </div> <!-- col -->
                        <div class="col-md-6 sm-m-30px-t">
                          <div class="side-title p-50px-l md-p-0px-l">
                            <h2 class="dark-color sub-title m-0px m-20px-b">Dana sends you what you need</h2>
                            <p class="large-text">Before your meetings, Dana will send you notes and meeting history for contacts.  After your meeting, Dana will ask for any updates.  All you have to do is send an email response for next time.</p>
                            <div class="p-15px-t">
                              <a class="btn btn-theme" href="#">Get Free Try Now</a>
                            </div>
                          </div>
                        </div>
                      </div> <!-- row -->
                    </div><!-- tab content -->
                  </div>
                </div> <!-- Tab style -->
              </div> <!-- col -->
            </div> <!-- row -->

          </div>

        </section>
        <!--
        =====================
        Feature
        =====================
        -->
        <!-- <section class="section gray-bg border-bottom">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-6">
                <div class="side-title p-50px-r md-p-0px-r">
                  <h2 class="dark-color sub-title m-0px m-20px-b">Integrate with your calendar and contacts</h2>
                  <p class="large-text">After setup, Dana presents your contacts, the last time you’ve seen them, and key information in a simple unified dashboard</p>

                </div>
              </div>
              <div class="col-md-6 text-center sm-m-30px-t">
                <img src="static/img/767x767.jpg" title="" alt="">
              </div>
            </div>
          </div>
        </section> -->
        <section class="section gray-bg border-bottom" v-if="true">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-6">
                <div class="side-title p-50px-l md-p-0px-l m-20px-b">
                  <h2 class="dark-color sub-title m-0px m-20px-b font-alt">Better Documentation Process</h2>
                  <p class="">With Codoc, see documentation coverage of your codebase and require documentation for new code commits.</p>
                  <p>Integrations with email, Slack, and GitHub allow engineers to quickly leave documentation at the right place.  With Codoc, documentation stays up-to-date. </p>
                  <!-- <div class="p-15px-t">
                    <a class="btn btn-theme" href="#">Get Free Try Now</a>
                  </div>-->
                </div>
              </div> <!-- col -->

              <div class="col-md-6 text-center sm-m-30px-b">
                <lightbox
                  :thumbnail="require('../assets/landing/mp2.png')"
                  :images="[require('../assets/landing/mp2_lg.png')]"
                >
                  <lightbox-default-loader slot="loader"></lightbox-default-loader> <!-- If you want to use built-in loader -->
                  <!-- <div slot="loader"></div> --> <!-- If you want to use your own loader -->
                </lightbox>
              </div> <!-- col -->
            </div> <!-- row -->
          </div>
        </section>
        <section class="section gray-bg border-bottom"  v-if="true">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-6 text-center sm-m-30px-t">
                <lightbox
                  :thumbnail="require('../assets/landing/mp3.png')"
                  :images="[require('../assets/landing/mp3_lg.png')]"
                >
                  <lightbox-default-loader slot="loader"></lightbox-default-loader> <!-- If you want to use built-in loader -->
                  <!-- <div slot="loader"></div> --> <!-- If you want to use your own loader -->
                </lightbox>
              </div> <!-- col -->
              <div class="col-md-6">
                <div class="side-title p-50px-r md-p-0px-r m-35px-t">
                  <h2 class="dark-color sub-title m-0px m-20px-b font-alt">Increase efficiency with better documentation</h2>
                  <p class="">Codoc documentation maps directly onto code. Open any file, and view a hierarchy of all relevant documentation kept up-to-date.</p>
                  <p>Empower new and existing engineers to get quickly up to speed with Codoc's intuitive code viewer.</p>
                  <!-- <div class="p-15px-t">
                    <a class="btn btn-theme" href="#">Get Free Try Now</a>
                  </div> -->
                </div>
              </div> <!-- col -->
            </div> <!-- row -->
          </div>
        </section>
        <!-- <section id="why" class="section border-bottom gray-bg-g shapes-section">
          <div class="container">
            <div class="row justify-content-center m-45px-b md-m-25px-b">
                <div class="col-md-10 col-lg-8 col-xl-7">
                  <div class="section-title text-center">
                    <h2 class="dark-color font-alt">Why use Dana?</h2>
                    <p>Dana helps you maintain lasting relationships</p>
                  </div>
                </div>
            </div>
            <div class="row">
              <div class="col-md-4 m-15px-tb">
                <div class="feature-box theme-hover box-shadow">
                  <div class="icon">
                    <i class="ti-check-box theme-color"></i>
                  </div>
                  <div class="feature-content">
                    <h4 class="dark-color font-alt">Remember key details</h4>
                    <p>Do you remember what your coworker's son name?  The last time your friend was in town? <br/></br>  Dana helps you log and remember the details you care about.</p>
                  </div>
                </div>
              </div>
              <div class="col-md-4 m-15px-tb">
                <div class="feature-box theme-hover box-shadow">
                  <div class="icon">
                    <i class="ti-signal theme-color"></i>
                  </div>
                  <div class="feature-content">
                    <h4 class="dark-color font-alt">Stay in touch</h4>
                    <p>It's easy for life to get in the way. Dana shows you how long it's been since you've chatted with your contacts.<br/> <br/> Remember to follow-up with the people you care about.</p>
                  </div>
                </div>
              </div>
              <div class="col-md-4 m-15px-tb">
                <div class="feature-box theme-hover box-shadow">
                  <div class="icon">
                    <i class="ti-wand theme-color"></i>
                  </div>
                  <div class="feature-content">
                    <h4 class="dark-color font-alt">Reach out effectively</h4>
                    <p>Need a favor? Dana makes it easy to reach out to your network.  <br></br> Send your next email with the context of the last time you met and what you talked about.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> -->
        <section id="privacy" class="section border-bottom darkgray-bg-g shapes-section" v-if="false">
          <div class="container">
            <div class="row justify-content-center m-45px-b md-m-25px-b">
                <div class="col-md-10 col-lg-8 col-xl-7">
                  <div class="section-title text-center">
                    <h2 class="dark-color font-alt">Built to be private</h2>
                    <p class="subheader">Any information you send Dana remains yours. Dana is built with security and data portability in mind.</p>
                  </div>
                </div> <!-- col -->
            </div>
            <div class="row">
              <div class="col-md-4 m-15px-tb">
                <div class="feature-box theme-hover box-shadow">
                  <div class="icon">
                    <i class="ti-lock theme-color"></i>
                  </div>
                  <div class="feature-content">
                    <h4 class="dark-color font-alt">Privacy</h4>
                    <p>We'll <b>never sell or give your data to any third parties</b>. Dana is supported by subscriptions, not ads.</p>
                  </div>
                </div>
              </div> <!-- col -->
              <div class="col-md-4 m-15px-tb">
                <div class="feature-box theme-hover box-shadow">
                  <div class="icon">
                    <i class="ti-shield theme-color"></i>
                  </div>
                  <div class="feature-content">
                    <h4 class="dark-color font-alt">Security</h4>
                    <!-- https://cloud.google.com/firestore/docs/server-side-encryption -->
                    <p>All data stored by Dana is encrytped under the <a href="https://en.wikipedia.org/wiki/Advanced_Encryption_Standard" target="_blank">256-bit Advanced Encryption Standard</a>.</p>
                    <p>In addition, Dana's website uses TLS (Transport Layer Security) to keep data secure in transit.</p>
                  </div>
                </div>
              </div> <!-- col -->
              <div class="col-md-4 m-15px-tb">
                <div class="feature-box theme-hover box-shadow">
                  <div class="icon">
                    <i class="ti-harddrives theme-color"></i>
                  </div>
                  <div class="feature-content">
                    <h4 class="dark-color font-alt">Data Ownership and Export</h4>
                    <p>Any information you send to Dana remains yours. Export your data at any time, free of charge.</p>
                  </div>
                </div>
              </div> <!-- col -->
            </div> <!-- row -->
          </div>
        </section>
        <!--
        =====================
        Price
        =====================
        -->
        <section id="pricing" class="section gray-bg border-bottom shapes-section" v-if="false">
          <div class="container">
            <div class="row justify-content-center m-45px-b md-m-25px-b">
                <div class="col-md-10 col-lg-8 col-xl-7">
                  <div class="section-title text-center">
                    <h2 class="dark-color font-alt">Pricing</h2>
                    <p>Dana is <b>free forever</b> for most users, and is $8/month for users with more than 50 contacts.</p>
                  </div>
                </div>
            </div>
            <div class="row">
              <div class="col-md-4 m-15px-tb offset-md-2">
                  <div class="price-table hover-shadow box-shadow active">
                    <div class="pt-head theme-bg-lighter">
                      <h6>Basic</h6>
                      <h4 class="dark-color font-alt">Free</h4>
                      <p>(it's free forever!)</p>
                    </div>
                    <div class="pt-body">
                      <ul>
                        <li><b>Up to 50</b> active contacts</li>
                        <li>Integration with Google Calendar </li>
                        <!-- <li>Up to 6 pre-meeting emails / month</li> -->
                      </ul>
                    </div>
                    <div class="pt-action">
                      <router-link class="btn btn-theme" to="/flow">Get Started</router-link>
                    </div>
                  </div>
              </div>
              <div class="col-md-4 m-15px-tb">
                  <div class="price-table hover-shadow box-shadow active">
                    <div class="pt-head theme-bg-light">
                      <h6>Premium</h6>
                      <h4 class="font-alt"><span>$</span>8</h4>
                      <p>Per Month</p>
                    </div>
                    <div class="pt-body">
                      <ul>
                        <li><b>Unlimited</b> Contacts</li>
                        <li>Integrations with Google Calendar, SMS, and Facebook Messenger.</li>
                      </ul>
                    </div>
                    <div class="pt-action">
                        <router-link class="btn btn-theme" to="/flow">Get Started</router-link>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </section>
        <section id="started" class="section border-bottom gray-bg-g shapes-section">
          <div class="container">
            <div class="row justify-content-center "> <!-- m-45px-b md-m-25px-b -->
                <div class="col-md-10 col-lg-8 col-xl-7">
                  <div class="section-title text-center">
                    <h2 class="dark-color font-alt">Ready to get started?</h2>
                    <p>Make your team amazing with better documentation.</p>
                    <center>
                      <get-started-form />
                    </center>
                    <div class="pt-action" v-if="false">
                        <router-link to="/flow" class="btn btn-theme m-20px-tb">Get Started for Free</router-link>
                    </div>
                  </div>
                </div> <!-- col -->
            </div>
          </div>
        </section>
      <!-- <modal name="signup-confirm" class="signup-confirm-modal" height="auto">
        <div class="modal-content__container">
          <h3>Thanks for signing up!</h3>
          <h6>What happens now?</h6>
          <p>If you entered a Tumblr, we'll start backing up your Tumblr and transferring all your posts.</p>
          <p>When that's done, we'll send you an email to your transferred blog.  You'll also set a password for your new Tapblr account.</p>
          <b>Please note you will not be able to login until transferring is completed.</b>
          <p></p>
        </div>
      </modal> -->
      <foot-component />
    </div>
  </body>
</template>

<script>
import { firebase, firebaseui, firestoreDB } from '@/common/firebaseConfig.js'
import GetStartedForm from '@/components/GetStartedForm.vue'
// import DemoButton from '@/components/DemoButton.vue'
// import SearchPage from '@/pages/SearchPage.vue'
const axios = require('axios');
export default {
  components: {
    'get-started-form': GetStartedForm
  },
  data: function () {
    return {
    }
  },
  mounted: function () {
    console.log("Home page mounted abc");
    // Start scroll animation effects
    this.toggleScroll();
  },
  methods: {
    toggleScroll: function () {
      $('header a[href*="#"]:not([href="#"]), .got-to a[href*="#"]:not([href="#"])').on('click', function() {
            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname) {
              var target = $(this.hash);
                  target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                  if (target.length) {
                    $('html,body').animate({
                      scrollTop: target.offset().top - 70,
                      }, 1000);
                      return false;
                  }
            }
        });
    },
    toggleFixedHeader: function (e) {
      var HscrollTop  = e.target.scrollTop;
      console.log($)
      if (HscrollTop >= 100) {
         $('header').addClass('fixed-header');
      }
      else {
         $('header').removeClass('fixed-header');
      }
    },
  }
}
</script>

<style lang="scss">
  @import '~styles/variables.scss';
  @import '~styles/basetheme';
  @import '~styles/basecolors';
</style>
<style lang="scss" scoped>
  section {
    position: relative;
  }
  .highlight-section {
    color: #fff;
  }
  .btn-bar {
    .subtitle {
      font-size: 12px;
      margin-top: 6px!important;
      opacity: .75
    }
  }
</style>

<style lang="scss">
@import '~styles/variables.scss';
@media (max-width: 991px) {
}

</style>
